export default "__VITE_ASSET__Ci0Ohm68__"